import Layout from '@/layout/Index.vue'

export default [{
  path: '/incomeTransfer',
  component: Layout,
  redirect: '/incomeTransfer/list',
  meta: { title: '收益金转商城积分' },
  children: [{
    path: 'list',
    meta: { title: '收益金转商城积分', activeMenu: '/incomeTransfer/list' },
    component: () => import('@/views/incomeTransfer/IncomeTransfer.vue')
  }]
}]
